<template>
  <el-dropdown trigger="click" @command="onCommand">
    <span class="ec-action-trigger">
      <slot name="trigger">
        <i class="bi bi-three-dots-vertical"></i>
      </slot>
    </span>
    <el-dropdown-menu slot="dropdown">
      <template v-for="item in resolvedItems">
        <el-dropdown-item
          v-if="!item.separator"
          :key="item.key"
          :command="item.key"
          :disabled="item.disabled"
        >
          <i v-if="item.icon" :class="'bi bi-' + item.icon" style="margin-right: 6px;" />
          <span :class="item.variant === 'danger' ? 'ec-action-menu__danger' : ''">{{ item.label }}</span>
        </el-dropdown-item>
        <li v-else :key="'sep-' + item.key" class="el-dropdown-menu__item--divided" style="margin: 4px 0;" />
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'EcActionMenu',
  props: {
    // Accept both `items` and `actions` for compatibility
    items: { type: Array, default: null },
    actions: { type: Array, default: null },
  },
  computed: {
    resolvedItems() {
      return this.items || this.actions || []
    },
  },
  methods: {
    onCommand(key) {
      this.$emit('command', key)
      this.$emit('select', key)
    },
  },
}
</script>

<style scoped>
.ec-action-trigger {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 1rem;
  color: var(--ec-text-muted, #6b7280);
  transition: background 0.15s, color 0.15s;
  display: inline-flex;
  align-items: center;
}
.ec-action-trigger:hover {
  background: var(--ec-bg-muted, #f3f4f6);
  color: var(--ec-text-color, #1f2937);
}
.ec-action-menu__danger {
  color: var(--ec-danger, #dc2626);
}
</style>
